import axios from "axios";

import ENV from "../../util/env-config";

class Service {
  static abortDropKey(requestData) {
    return axios.post(`${ENV.keylockerBase}/drop/abort`, requestData);
  }

  static init(requestData) {
    return axios.post(ENV.keylockerBase + "/keylockers/init", requestData);
  }

  static getStatus(requestData) {
    return axios.post(ENV.keylockerBase + "/keylockers/status", requestData);
  }
}

export default Service;
